import React from "react";

interface PopoverProps {
    isOpen: boolean;
    label: string | string[];
}

const PopOver: React.FC<PopoverProps> = ({ isOpen, label }) => {
    return (
        <div className="relative">
            {isOpen && (
                <div className="sampleLabel absolute z-9999 p-3 text-sm text-gray-800 bg-white border rounded shadow -top-5 -left-3">
                    {Array.isArray(label) 
                        ? label.map((line, idx) => <div key={idx}>{line}</div>) 
                        : <div>{label}</div>}
                </div>
            )}
        </div>
    );
}

export default PopOver